import React, { FC, useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  makeStyles,
  Theme,
  Typography,
  TextField,
  DialogActions,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormHelperText
} from '@material-ui/core';
import { DialogTitle } from 'components/Dialog';
import { BLACK, RED, WHITE, GREEN_MOBILE, BLUE_PRIMARY, YELLOW_MOBILE, ORANGE_MOBILE, PRIMARY_MOBILE, GREY } from 'constants/colors';
import Close from '@material-ui/icons/Close';
import NumberFormat from 'components/NumberFormat';
import { format } from 'date-fns';
import axios from 'axios';
import { INVOICE_ITEM_LAST_PURCHASE_BASE_URL } from 'constants/url';
type typeDiscount = {
  discountUnit: number;
  orderDate: string;
  price: number;
};

interface Props {
  openEdit: boolean;
  showComponent: boolean;
  productSelectedItem: OrderItems[];
  discountResource: typeDiscount[];
  idClick: number;
  qtyEdit: number;
  discount: number;
  price: number;
  partner: any;
  setOpenEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setQtyEdit: React.Dispatch<React.SetStateAction<number>>;
  setDiscount: React.Dispatch<React.SetStateAction<number>>;
  setPrice: React.Dispatch<React.SetStateAction<number>>;

  handleEditItem: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    borderRadius: '15px',
    padding: '7px 0'
  },

  titleContainer: {
    fontWeight: 500,
    fontSize: '1.2rem',
    color: BLACK,
    paddingLeft: '6px'
  },
  containerContent: {
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      maxWidth: '70vh'
    }
  },
  containerAction: {
    marginBottom: theme.spacing(1)
  },
  spacing: {
    marginTop: theme.spacing(2)
  },
  // Typography sizing adjustments for mobile view
  historyTitle: {
    fontSize: '1rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.95rem'
    }
  },
  historyHeaderText: {
    fontSize: '12px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px'
    }
  },
  historyValueText: {
    fontSize: '13px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px'
    }
  },
  historyQtyText: {
    fontSize: '13px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px'
    }
  },
  historyNoticeText: {
    fontSize: '12px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px'
    }
  },
  historyDateText: {
    fontSize: '12px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px'
    }
  }
}));

const ModalDiscount: FC<Props> = props => {
  const classes = useStyles();

  const {
    openEdit,
    setOpenEdit,
    showComponent,
    handleEditItem,
    idClick,
    productSelectedItem,
    qtyEdit,
    price,
    discount,
    discountResource,
    setQtyEdit,
    setPrice,
    setDiscount,
    partner
  } = props;

  const getItem = productSelectedItem && productSelectedItem.find(value => value.ProductId === idClick);

  console.log('getItem-->', getItem);
  console.log('partner-->', partner);
  const [hasDiscount, setHasDiscount] = useState(false);
  const [historyUser, setHistoryUser] = useState<{ date: string; price: number; discountUnit?: number; totalItem?: number }[]>([]);
  const getHistory = async () => {
    // Hindari pemanggilan API saat PartnerId atau ProductId belum valid
    if (((partner && partner.id) || 0) < 1 || ((getItem && getItem.ProductId) || 0) < 1) {
      return;
    }
    const params = new URLSearchParams();
    params.append('PartnerId', String(partner.id));
    params.append('ProductId', String(getItem?.ProductId || 0));
    params.append('limit', '5');
    try {
      const { data } = await axios.get(`${INVOICE_ITEM_LAST_PURCHASE_BASE_URL}?${params.toString()}`);
      console.log('data -->', data);

      const items: any[] = Array.isArray(data) ? data : data && Array.isArray(data.data) ? data.data : [];
      if (items.length > 0) {
        setHistoryUser(
          // eslint-disable-next-line
          items.map((value: any) => {
            return {
              date: value.orderDate || value.createdAt,
              price: Number(value.price) || 0,
              discountUnit: Number(value.discountUnit) || 0,
              totalItem: typeof value.totalItem === 'number' ? value.totalItem : undefined
            };
          })
        );
      }
    } catch (error) {
      console.log('error :', error);
    }
  };

  useEffect(() => {
    getHistory();
  }, [getItem?.ProductId, partner.id]);

  // Hitung harga minimum dan maksimum dari riwayat (jika tersedia)
  const historyPrices = historyUser.map(h => Number(h.price)).filter(p => !Number.isNaN(p));
  const minHistoryPrice = historyPrices.length > 0 ? Math.min(...historyPrices) : null;
  const maxHistoryPrice = historyPrices.length > 0 ? Math.max(...historyPrices) : null;
  const afterDiscountPrice = price - discount;

  // Hitung rentang discountUnit dari riwayat (hanya jika ada discountUnit)
  const historyDiscountUnits = historyUser.map(h => Number(h.discountUnit)).filter(d => !Number.isNaN(d));
  const minHistoryDiscountUnit = historyDiscountUnits.length > 0 ? Math.min(...historyDiscountUnits) : null;
  const maxHistoryDiscountUnit = historyDiscountUnits.length > 0 ? Math.max(...historyDiscountUnits) : null;

  return (
    <Dialog
      open={openEdit}
      onClose={() => {
        setOpenEdit(false);
      }}
      fullWidth={showComponent ? true : false}
      style={{ maxHeight: 80 + 'vh', marginTop: showComponent ? '60px' : '0' }}
      scroll='paper'
    >
      <DialogTitle>
        <Grid item container direction='row' justify='space-between' alignItems='center' xs={12}>
          <React.Fragment>
            <Typography className={classes.titleContainer}>Edit Qty & Discount</Typography>
            <Close
              fontSize='small'
              color='action'
              onClick={() => {
                setOpenEdit(false);
                setHasDiscount(false);
              }}
              style={{ cursor: 'pointer' }}
            />
          </React.Fragment>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.containerContent}>
        <Grid xs={12}>
          <FormControl variant='outlined' size='small' required fullWidth>
            <InputLabel htmlFor='outlined-adornment-amount'>Qty Request</InputLabel>
            <OutlinedInput
              id='outlined-adornment-amount'
              value={qtyEdit}
              autoComplete='off'
              inputProps={{
                inputMode: 'numeric'
              }}
              onChange={e => setQtyEdit(Number(e.target.value))}
              error={qtyEdit > ((getItem && getItem.qtyAvailable) || 0) || qtyEdit < 1}
              endAdornment={
                <InputAdornment position='end' style={{ color: BLACK }}>
                  {(getItem && getItem.typeUnit) || '-'}
                </InputAdornment>
              }
              labelWidth={100}
            />
          </FormControl>

          {qtyEdit > ((getItem && getItem.qtyAvailable) || 0) && (
            <Grid xs={12} container>
              <FormHelperText error={true}>Qty melebihi stok jual ({getItem && getItem.qtyAvailable})</FormHelperText>
            </Grid>
          )}
          {qtyEdit < 1 && (
            <Grid xs={12} container>
              <FormHelperText error={true}>Qty tidak boleh kurang dari 1</FormHelperText>
            </Grid>
          )}
        </Grid>

        <Grid xs={12} className={classes.spacing}>
          <FormControl variant='outlined' size='small' required fullWidth>
            <InputLabel htmlFor='outlined-adornment-amount'>Discount per Item</InputLabel>
            <OutlinedInput
              id='outlined-adornment-amount'
              startAdornment={<InputAdornment position='start'>Rp</InputAdornment>}
              labelWidth={140}
              inputProps={{
                inputMode: 'numeric'
              }}
              autoComplete='off'
              error={
                discount >= ((getItem && getItem.price) || 0) ||
                (minHistoryDiscountUnit !== null &&
                  maxHistoryDiscountUnit !== null &&
                  (discount < minHistoryDiscountUnit || discount > maxHistoryDiscountUnit))
              }
              value={Number.isNaN(discount) ? 0 : new Intl.NumberFormat('id-ID').format(discount)}
              onFocus={() => setHasDiscount(true)}
              onChange={e => {
                const raw = e.target.value;
                if (raw === '') {
                  setDiscount(0);
                } else {
                  setDiscount(
                    Number(
                      raw
                        .split('.')
                        .join('')
                        .replace(/\,/g, '')
                    )
                  );
                }
              }}
            />
          </FormControl>
          {discount >= ((getItem && getItem.price) || 0) && (
            <FormHelperText error={true}>Diskon tidak boleh melebihi atau sama dengan harga produk</FormHelperText>
          )}
          {minHistoryDiscountUnit !== null &&
            maxHistoryDiscountUnit !== null &&
            (discount < minHistoryDiscountUnit || discount > maxHistoryDiscountUnit) && (
              <FormHelperText error={true}>
                {minHistoryDiscountUnit === maxHistoryDiscountUnit
                  ? `Diskon per item harus sama dengan ${new Intl.NumberFormat('id-ID').format(minHistoryDiscountUnit)} (riwayat diskon)`
                  : `Diskon per item harus antara ${new Intl.NumberFormat('id-ID').format(minHistoryDiscountUnit)} – ${new Intl.NumberFormat(
                      'id-ID'
                    ).format(maxHistoryDiscountUnit)} (riwayat diskon)`}
              </FormHelperText>
            )}
        </Grid>
        {historyUser.length > 0 && (
          <Grid xs={12} style={{ margin: '0.5em 0' }}>
            <Typography variant='h6' style={{ color: YELLOW_MOBILE, fontWeight: 500 }} className={classes.historyTitle}>
              Riwayat 5 penjualan terakhir:
            </Typography>
            <Grid xs={12} container justify='space-between'>
              <Grid xs={4}>
                <Typography style={{ color: 'lightgrey' }} className={classes.historyHeaderText}>
                  Harga/item sebelum disc
                </Typography>
              </Grid>
              <Grid xs={3}>
                <Typography style={{ color: 'lightgrey' }} className={classes.historyHeaderText}>
                  Diskon/
                </Typography>
                <Typography style={{ color: 'lightgrey' }} className={classes.historyHeaderText}>
                  item
                </Typography>
              </Grid>
              <Grid xs={1}>
                <Typography style={{ color: 'lightgrey' }} className={classes.historyHeaderText}>
                  Qty
                </Typography>
              </Grid>
              <Grid xs={3}>
                <Typography style={{ color: 'lightgrey' }} className={classes.historyHeaderText}>
                  Harga/item sesudah disc
                </Typography>
              </Grid>
              {historyUser.map((value, key) => (
                <Grid xs={12} container justify='space-between' key={key}>
                  <Grid xs={4}>
                    <Typography className={classes.historyValueText}>
                      <NumberFormat value={value.price + (value.discountUnit ?? 0)} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                    </Typography>
                    <Typography style={{ color: 'lightgrey' }} className={classes.historyDateText}>
                      {format(new Date(value.date), 'dd-MM-yyyy')}
                    </Typography>
                  </Grid>
                  <Grid xs={3}>
                    <Typography className={classes.historyValueText}>
                      <NumberFormat value={value.discountUnit || 0} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                    </Typography>
                  </Grid>
                  <Grid xs={1}>
                    <Typography className={classes.historyQtyText}>{value.totalItem ?? '-'}</Typography>
                  </Grid>
                  <Grid xs={3}>
                    <Typography className={classes.historyValueText}>
                      <NumberFormat value={value.price} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}
        {historyUser.length < 5 && historyUser.length > 0 && (
          <Typography style={{ color: 'lightgrey' }} className={classes.historyNoticeText}>
            Mitra ini belum memiliki 5 penjualan sampai saat ini
          </Typography>
        )}
        <Grid xs={12} className={classes.spacing}>
          <FormControl variant='outlined' size='small' required fullWidth>
            <InputLabel htmlFor='outlined-adornment-amount'>Total Discount</InputLabel>
            <OutlinedInput
              id='outlined-adornment-amount'
              startAdornment={<InputAdornment position='start'>Rp</InputAdornment>}
              labelWidth={90}
              disabled
              value={Number.isNaN(discount) ? 0 : new Intl.NumberFormat('id-ID').format(discount * qtyEdit)}
            />
          </FormControl>
        </Grid>

        <Grid xs={12} className={classes.spacing}>
          <FormControl variant='outlined' size='small' required fullWidth>
            <InputLabel htmlFor='outlined-adornment-amount'>Harga per Item</InputLabel>
            <OutlinedInput
              id='outlined-adornment-amount'
              startAdornment={<InputAdornment position='start'>Rp</InputAdornment>}
              labelWidth={140}
              inputProps={{
                inputMode: 'numeric'
              }}
              autoComplete='off'
              error={price < ((getItem && getItem.price) || 0)}
              value={Number.isNaN(price) ? 0 : new Intl.NumberFormat('id-ID').format(price)}
              //onFocus={() => setHasDiscount(true)}
              onChange={e => {
                if (e.target.value === '' && Number.isNaN(price)) {
                  setPrice(0);
                } else {
                  setPrice(
                    Number(
                      e.target.value
                        .split('.')
                        .join('')
                        .replace(/\,/g, '')
                    )
                  );
                }
              }}
            />
          </FormControl>
          {price < ((getItem && getItem.price) || 0) && (
            <FormHelperText error={true}>Harga per produk tidak boleh kecil dari harga rute</FormHelperText>
          )}
        </Grid>

        <Grid xs={12} className={classes.spacing}>
          <FormControl variant='outlined' size='small' required fullWidth>
            <InputLabel htmlFor='outlined-adornment-amount'>Total Harga</InputLabel>
            <OutlinedInput
              id='outlined-adornment-amount'
              startAdornment={<InputAdornment position='start'>Rp</InputAdornment>}
              labelWidth={90}
              disabled
              value={Number.isNaN(price) ? 0 : new Intl.NumberFormat('id-ID').format(price * qtyEdit - discount * qtyEdit)}
            />
          </FormControl>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.containerAction}>
        <Grid item container direction='row' justify='space-evenly' alignItems='center'>
          <Grid xs={11}>
            <Button
              size='small'
              fullWidth
              className={classes.button}
              color='primary'
              onClick={handleEditItem}
              disabled={
                qtyEdit > ((getItem && getItem.qtyAvailable) || 0) ||
                discount >= ((getItem && getItem.price) || 0) ||
                qtyEdit < 1 ||
                price < ((getItem && getItem.price) || 0)
              }
            >
              Simpan
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDiscount;
